// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CheckSquareFilledSvg from "@ant-design/icons-svg/es/asn/CheckSquareFilled";
import AntdIcon from '../components/AntdIcon';

var CheckSquareFilled = function CheckSquareFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CheckSquareFilledSvg
  }));
};

CheckSquareFilled.displayName = 'CheckSquareFilled';
export default React.forwardRef(CheckSquareFilled);